const WHITE_SVG =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IndoaXRlIi8+PC9zdmc+';

export function isSamsungInternet() {
  if (typeof navigator === 'undefined') return false;
  return /SamsungBrowser/i.test(navigator.userAgent);
}

function sampleWhiteSvgPixel() {
  return new Promise((resolve) => {
    try {
      const img = new Image();
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = 1;
          canvas.height = 1;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          if (!ctx) {
            resolve(null);
            return;
          }
          ctx.drawImage(img, 0, 0);
          const [r, g, b] = ctx.getImageData(0, 0, 1, 1).data;
          resolve({ r, g, b });
        } catch {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = WHITE_SVG;
    } catch {
      resolve(null);
    }
  });
}

/**
 * Best-effort detection of Samsung Internet Dark Sites (force-dark).
 * There is no official API — we probe whether a pure-white SVG is darkened
 * when drawn to canvas (Samsung applies its filter to SVG → canvas).
 *
 * @returns {Promise<'dark-sites' | 'light-sites' | 'unknown'>}
 *   - dark-sites  → menu would show "Light sites" (browser is darkening)
 *   - light-sites → menu would show "Dark sites" (no browser darkening)
 *   - unknown     → probe failed
 */
export async function detectSamsungSitesMode() {
  if (!isSamsungInternet()) return 'unknown';

  const pixel = await sampleWhiteSvgPixel();
  if (!pixel) return 'unknown';

  const { r, g, b } = pixel;
  const isDarkened = r < 250 || g < 250 || b < 250;
  return isDarkened ? 'dark-sites' : 'light-sites';
}

/** @deprecated use detectSamsungSitesMode */
export async function detectSamsungForceDark() {
  return (await detectSamsungSitesMode()) === 'dark-sites';
}
